import { ResponseModel } from '@agent/agent-interface/helpzone/knowledge-base/models/responseModel';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { getSearchResults, getSuggestedResults } from '../agent.store';
import { KnowledgeBaseDispatcher } from './knowledge-base.dispatcher';

@Injectable({
  providedIn: 'root',
})
export class KnowledgeBaseFacade {
  readonly suggestedResults$ = this.store$.pipe(select(getSuggestedResults));
  readonly searchResults$ = this.store$.pipe(select(getSearchResults));

  constructor(private readonly store$: Store, private readonly knowledgeBaseDispatcher: KnowledgeBaseDispatcher) {}

  suggestedResults(suggestedResults: ResponseModel[]) {
    this.store$.dispatch(this.knowledgeBaseDispatcher.suggestedResults(suggestedResults));
  }

  searchResults(searchResults: ResponseModel[]) {
    this.store$.dispatch(this.knowledgeBaseDispatcher.searchResults(searchResults));
  }
}
